import { UserSession } from "../models/UserSession";

let activeUser: UserSession;

export let breadcrumbs: any[] = [];

// localStorage keys for persisting active client and site
const STORAGE_KEYS = {
    ACTIVE_CLIENT_ID: 'dsf_active_client_id',
    ACTIVE_CLIENT_NAME: 'dsf_active_client_name',
    ACTIVE_CLIENT_LOGO_S3_KEY: 'dsf_active_client_logo_s3_key',
    ACTIVE_SITE_ID: 'dsf_active_site_id',
    ACTIVE_SITE_NAME: 'dsf_active_site_name',
    ACTIVE_TYPE: 'dsf_active_type',
    LOGO_S3_KEY: 'dsf_logo_s3_key',
};

export function setUserDetails(user: UserSession) {
    activeUser = user;
}

export function getUserDetails(): UserSession {
    return activeUser;
}

/**
 * Save the active client information to localStorage
 */
export function saveActiveClient(clientId?: string, clientName?: string, logoS3Key?: string) {
    try {
        if (clientId) {
            localStorage.setItem(STORAGE_KEYS.ACTIVE_CLIENT_ID, clientId);
        } else {
            localStorage.removeItem(STORAGE_KEYS.ACTIVE_CLIENT_ID);
        }
        if (clientName) {
            localStorage.setItem(STORAGE_KEYS.ACTIVE_CLIENT_NAME, clientName);
        } else {
            localStorage.removeItem(STORAGE_KEYS.ACTIVE_CLIENT_NAME);
        }
        if (logoS3Key) {
            localStorage.setItem(STORAGE_KEYS.ACTIVE_CLIENT_LOGO_S3_KEY, logoS3Key);
        } else {
            localStorage.removeItem(STORAGE_KEYS.ACTIVE_CLIENT_LOGO_S3_KEY);
        }
    } catch (error) {
        console.error('Error saving active client to localStorage:', error);
    }
}

/**
 * Save the active site information to localStorage
 */
export function saveActiveSite(siteId?: string, siteName?: string) {
    try {
        if (siteId) {
            localStorage.setItem(STORAGE_KEYS.ACTIVE_SITE_ID, siteId);
        } else {
            localStorage.removeItem(STORAGE_KEYS.ACTIVE_SITE_ID);
        }
        if (siteName) {
            localStorage.setItem(STORAGE_KEYS.ACTIVE_SITE_NAME, siteName);
        } else {
            localStorage.removeItem(STORAGE_KEYS.ACTIVE_SITE_NAME);
        }
    } catch (error) {
        console.error('Error saving active site to localStorage:', error);
    }
}

/**
 * Save the active type to localStorage
 */
export function saveActiveType(activeType?: string) {
    try {
        if (activeType) {
            localStorage.setItem(STORAGE_KEYS.ACTIVE_TYPE, activeType);
        } else {
            localStorage.removeItem(STORAGE_KEYS.ACTIVE_TYPE);
        }
    } catch (error) {
        console.error('Error saving active type to localStorage:', error);
    }
}

/**
 * Save the logo s3 key to localStorage
 */
export function saveLogoS3Key(logoS3Key?: string) {
    try {
        if (logoS3Key) {
            localStorage.setItem(STORAGE_KEYS.LOGO_S3_KEY, logoS3Key);
        } else {
            localStorage.removeItem(STORAGE_KEYS.LOGO_S3_KEY);
        }
    } catch (error) {
        console.error('Error saving logo s3 key to localStorage:', error);
    }
}

/**
 * Get the stored active client and site information from localStorage
 */
export function getStoredActiveSession(): Partial<UserSession> {
    try {
        const storedSession: Partial<UserSession> = {};
        
        const clientId = localStorage.getItem(STORAGE_KEYS.ACTIVE_CLIENT_ID);
        const clientName = localStorage.getItem(STORAGE_KEYS.ACTIVE_CLIENT_NAME);
        const clientLogoS3Key = localStorage.getItem(STORAGE_KEYS.ACTIVE_CLIENT_LOGO_S3_KEY);
        const siteId = localStorage.getItem(STORAGE_KEYS.ACTIVE_SITE_ID);
        const siteName = localStorage.getItem(STORAGE_KEYS.ACTIVE_SITE_NAME);
        const activeType = localStorage.getItem(STORAGE_KEYS.ACTIVE_TYPE);
        const logoS3Key = localStorage.getItem(STORAGE_KEYS.LOGO_S3_KEY);
        
        if (clientId) storedSession.client_id = clientId;
        if (clientName) storedSession.client_name = clientName;
        if (clientLogoS3Key) storedSession.client_logo_s3_key = clientLogoS3Key;
        if (siteId) storedSession.site_id = siteId;
        if (siteName) storedSession.site_name = siteName;
        if (activeType) storedSession.active_type = activeType as any;
        if (logoS3Key) storedSession.logo_s3_key = logoS3Key;
        
        return storedSession;
    } catch (error) {
        console.error('Error reading stored session from localStorage:', error);
        return {};
    }
}

/**
 * Clear all stored active session information from localStorage
 */
export function clearStoredActiveSession() {
    try {
        Object.values(STORAGE_KEYS).forEach(key => {
            localStorage.removeItem(key);
        });
    } catch (error) {
        console.error('Error clearing stored session from localStorage:', error);
    }
}
